module.exports = __webpack_public_path__ + "static/vascepaCapsuleMobile-974445cf8eee634f273498a3ae24dc12.png";